var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 14H11.3337V22H9.33366C8.96547 22 8.66699 21.7015 8.66699 21.3333V14.6666C8.66699 14.2985 8.96547 14 9.33366 14ZM12.8623 13.1381L17.1293 8.87107C17.2465 8.75377 17.4323 8.74058 17.5649 8.84011L18.1333 9.2664C18.4565 9.50875 18.6021 9.92169 18.5024 10.3131L17.7335 13.3333H22.0003C22.7367 13.3333 23.3337 13.9303 23.3337 14.6666V16.0695C23.3337 16.2437 23.2995 16.4162 23.2333 16.5772L21.1703 21.5871C21.0675 21.8369 20.824 22 20.5539 22H13.3337C12.9655 22 12.667 21.7015 12.667 21.3333V13.6095C12.667 13.4326 12.7372 13.2631 12.8623 13.1381Z",
    fill: "#4611A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsupIcon);
export default __webpack_public_path__ + "static/media/thumbsup-icon.a4b72540956b7a16cd22a53a483365c1.svg";
export { ForwardRef as ReactComponent };